import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  CustomForm,
  CustomFormItem,
  CustomTextInput,
  CustomMaskInput,
  CustomInput,
  CustomCheckbox,
  CustomImage,
  Text,
  useText,
} from '@src/components';
import { Form, Row, Col, Checkbox, Button } from 'antd';
import { useSelector } from 'react-redux';
import { UpCircleOutlined, DownCircleOutlined } from '@ant-design/icons';
import debounce from 'lodash/debounce';
import { formMailRegex, formPhoneRegex } from '@src/utils/formRule';
import iconBilgiSvg from '@src/assets/icons/icon-bilgi.svg';
import { DeviceType } from '@src/store/enums';
import '@src/styles/addNewCar/addDriverSelectInformation.scss';
import { useMediaQuery } from '@src/hooks/useMediaQuery';

const AddDriverSelectInformation = ({ index, setDriverDetails, driveDetails }) => {
  const [form] = Form.useForm();
  const isMobil = useMediaQuery({ query: '(max-width: 768px)' });
  const { selectVehicleDeviceTypeList } = useSelector((state) => state?.addCarType);
  const [isDriverInfoEnabled, setIsDriverInfoEnabled] = useState(false);
  const isSpecificDeviceType =
    selectVehicleDeviceTypeList?.deviceTypeId === DeviceType.TYPE_2 ||
    selectVehicleDeviceTypeList?.deviceTypeId === DeviceType.TYPE_10;

  const driverName = useText('driverName')
  const driverEMail = useText('driverEMail')
  
  useEffect(() => {
    if (
      isSpecificDeviceType ||
      (driveDetails &&
        (driveDetails.driverPhone ||
          driveDetails.driverName ||
          driveDetails.driverEmail ||
          driveDetails.sendDriverCode ||
          driveDetails.sendOrderCode))
    ) {
      setIsDriverInfoEnabled(true);
    }
  }, [isSpecificDeviceType, driveDetails]);

  useEffect(() => {
    if (driveDetails && Object.keys(driveDetails).length > 0) {
      form.setFieldsValue(driveDetails);
    }
  }, [driveDetails, form]);

  useEffect(() => {
    if (selectVehicleDeviceTypeList?.deviceTypeId === DeviceType.TYPE_17) {
      handleCheckboxChange();
    }
  }, [selectVehicleDeviceTypeList]);

  const handleCheckboxChange = () => {
    if (
      selectVehicleDeviceTypeList?.deviceTypeId !== DeviceType.TYPE_2 ||
      selectVehicleDeviceTypeList?.deviceTypeId !== DeviceType.TYPE_10
    ) {
      const newIsDriverInfoEnabled = !isDriverInfoEnabled;
      setIsDriverInfoEnabled(newIsDriverInfoEnabled);

      if (!newIsDriverInfoEnabled) {
        form.resetFields();
        setDriverDetails(index, {});
      }
    }
  };

  const formatPhoneNumber = (phone) => {
    let formattedPhone = phone.replace(/[^\d]/g, '');
    if (formattedPhone.startsWith('90')) {
      formattedPhone = formattedPhone.slice(2);
    }
    return formattedPhone;
  };

  const handleValuesChange = debounce((changedValues, allValues) => {
    if (changedValues.driverPhone) {
      allValues.driverPhone = formatPhoneNumber(changedValues.driverPhone);
    }

    setDriverDetails(allValues);
  }, 300);

  const handleFieldBlur = useCallback(() => {
    if (isSpecificDeviceType) {
      const allValues = form.getFieldsValue();

      const isDriverPhoneRequired = !!allValues.driverPhone;
      const isAnyCheckboxChecked = !!allValues.sendDriverCode;

      form.setFields([
        {
          name: 'driverPhone',
          errors:
            !isDriverPhoneRequired && isAnyCheckboxChecked
              ? [
                'Turpak sipariş kodunun sürüye gönderilmesini istiyorsanız lütfen sürücü telefonunu giriniz.',
              ]
              : [],
        },
        /*{
          name: 'sendDriverCode',
          errors:
            isDriverPhoneRequired && !isAnyCheckboxChecked
              ? [
                  'Sürücü Telefon alanı girilirse turpak sipariş kodu sürücüye gönderilsin zorunludur',
                ]
              : [],
        },*/
      ]);
    } else if (selectVehicleDeviceTypeList?.deviceTypeId === DeviceType.TYPE_17) {
      const allValues = form.getFieldsValue();
      const isDriverPhoneRequired = !!allValues.driverPhone;
      form.setFields([
        {
          name: 'driverPhone',
          errors: !isDriverPhoneRequired ? ['Sürücü telefon no eksiksiz giriniz.'] : [],
        },
        /*{
          name: 'sendDriverCode',
          errors:
            isDriverPhoneRequired && !isAnyCheckboxChecked
              ? [
                  'Sürücü Telefon alanı girilirse turpak sipariş kodu sürücüye gönderilsin zorunludur',
                ]
              : [],
        },*/
      ]);
    }
  }, [form]);

  return (
    <div className="add-driver-select-information">
      <Row justify={'space-between'} align="middle" className="header-row-title-3">
        <Checkbox
          className="custom-checkbox-wrapper"
          onChange={handleCheckboxChange}
          checked={isDriverInfoEnabled}
        >
          <Text t="iWantToEnterDriverInformation" />
        </Checkbox>
        <Button
          type="text"
          icon={
            isDriverInfoEnabled ? (
              <UpCircleOutlined style={{ color: '#1d2228', fontSize: '24px' }} />
            ) : (
              <DownCircleOutlined style={{ color: '#1d2228', fontSize: '24px' }} />
            )
          }
          onClick={handleCheckboxChange}
          className="toggle-button"
        />
      </Row>
      {isDriverInfoEnabled && (
        <CustomForm
          name={`driverForm-${index}`}
          className="filter-form"
          autoComplete="off"
          initialValues={{}}
          layout={'vertical'}
          form={form}
          onValuesChange={handleValuesChange}
        >
          <Row
            ggutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="form-item"
            style={{ marginBottom: '10px' }}
          >
            <Col span={isMobil ? 24 : 8}>
              <CustomFormItem
                label={<Text t="driverName" />}
                name="driverName"
                className={'delivery-address-county-form-item'}
                validateTrigger="onBlur"
                onBlur={handleFieldBlur}
              >
                <CustomTextInput
                  id={`driverName-textInput-${index}`}
                  placeholder={driverName}
                  autoComplete="off"
                  height={36}
                  onBlur={(e) => {
                    const value = e.target.value;
                    const formattedValue = value
                      .split(' ')
                      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                      .join(' ');
                    form.setFieldsValue({ driverName: formattedValue });
                  }}
                />
              </CustomFormItem>
            </Col>

            <Col span={isMobil ? 24 : 8}>
              <CustomFormItem
                label={
                  <span>
                    <Text t="driverPhone2" />
                    {form.getFieldValue('sendDriverCode') ||
                      selectVehicleDeviceTypeList?.deviceTypeId === DeviceType.TYPE_17 ? (
                      <span style={{ color: 'red' }}>*</span>
                    ) : (
                      ''
                    )}
                  </span>
                }
                name="driverPhone"
                className={'delivery-address-county-form-item'}
                rules={[
                  {
                    required:
                      form.getFieldValue('sendDriverCode') ||
                      selectVehicleDeviceTypeList?.deviceTypeId === DeviceType.TYPE_17,
                    validator: formPhoneRegex,
                    message: <Text t="enterDriverPhoneNumberCompletely" />,
                  },
                ]}
                validateTrigger="onBlur"
                onBlur={handleFieldBlur}
              >
                <CustomMaskInput
                  id={`add-drive-mobilePhones-maskInput-${index}`}
                  mask={'+\\90 (999) 999 99 99'}
                >
                  <CustomInput
                    id={`add-car-drive-mobile-phones-input-${index}`}
                    data-testid="drive-mobile-phones"
                    placeholder="( _ _ _ ) _ _ _   _ _   _ _"
                  />
                </CustomMaskInput>
              </CustomFormItem>
            </Col>

            <Col span={isMobil ? 24 : 8}>
              <CustomFormItem
                label={<Text t="driverEMail" />}
                className={'delivery-address-county-form-item'}
                name="driverEmail"
                rules={[
                  {
                    validator: formMailRegex,
                    message: <Text t="enterValidDriverEMail" />,
                  },
                ]}
                validateTrigger="onBlur"
                onBlur={handleFieldBlur}
              >
                <CustomInput
                  id={`add-drive-email-input-${index}`}
                  data-testid="email"
                  placeholder={driverEMail}
                />
              </CustomFormItem>
            </Col>
          </Row>

          {isSpecificDeviceType ? (
            <Row gutter={16} className="form-item" style={{ columnGap: '24px' }}>
              <Col span={12}>
                <CustomFormItem label={false} name="sendDriverCode" valuePropName="checked">
                  <CustomCheckbox id={`sendDriverCode-checkbox-${index}`} onBlur={handleFieldBlur}>
                    <span className="address-form-item">
                      <Text t="sendTurpakOrderCodeToDriver" />
                      <CustomImage
                        style={{ padding: '0px 10px 5px 8px', height: '20px' }}
                        src={iconBilgiSvg}
                        alt="turpak-icon-bilgi"
                      />
                    </span>
                  </CustomCheckbox>
                </CustomFormItem>
              </Col>
              {/*<Col span={12}>
                <CustomFormItem label={false} name="sendOrderCode" valuePropName="checked">
                  <CustomCheckbox id={`sendOrderCode-checkbox-${index}`} onBlur={handleFieldBlur}>
                    <span className="address-form-item">
                      <Text t="Turpak sipariş kodu sipariş yetkilisine gönderilsin" />
                      <CustomImage
                        style={{ padding: '0px 10px 5px 8px', height: '20px' }}
                        src={iconBilgiSvg}
                        alt="turpak-icon-bilgi"
                      />
                    </span>
                  </CustomCheckbox>
                </CustomFormItem>
              </Col>*/}
            </Row>
          ) : null}
        </CustomForm>
      )}
    </div>
  );
};

AddDriverSelectInformation.propTypes = {
  index: PropTypes.number.isRequired,
  setDriverDetails: PropTypes.func.isRequired,
  driveDetails: PropTypes.object.isRequired,
};

export default AddDriverSelectInformation;
